import styled from 'styled-components'

const MutedText = styled(({ value, children = value || '-', ...props }) => {
  const className = props.className ? props.className : 'text-center'
  return <div dangerouslySetInnerHTML={{ __html: children }} className={className} {...props} />
})`
  color: ${({ theme }) => theme.variables['$color-scorpion']};
`

export default (hoc) => MutedText
